module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.4ee9754.eot";